import { type Filter } from 'uplisting-frontend/utils/filters/types';
import { FilterId } from 'uplisting-frontend/utils/filters/abstract';

export function getFilterQueryParamName(filter: Filter): string {
  switch (filter.id) {
    case FilterId.upsellOrderStatus:
    case FilterId.clientStatementStatus:
      return 'status';
    case FilterId.property:
      return 'propertyIds';
    case FilterId.airbnbOfficialLink:
      return 'airbnbOfficialLinkIds';
    case FilterId.airbnbOfficialConnection:
      return 'airbnbOfficialConnectionIds';
    case FilterId.airbnbQualityState:
      return 'airbnbQualityStates';
    case FilterId.clientName:
      return 'clientIds';
    case FilterId.period:
      return 'period';
    case FilterId.clientStatementPaymentStatus:
      return 'paymentStatus';
    case FilterId.airbnbCancellationPolicy:
      return 'cancellationPolicies';
    case FilterId.country:
      return 'countries';
    case FilterId.city:
      return 'cities';
    case FilterId.knowledgeCenterCategory:
      return 'categories';
    case FilterId.knowledgeCenterStatus:
      return 'statuses';
    case FilterId.protectionStatus:
      return 'protectionStatuses';
    case FilterId.bookingWindow:
      return 'bookingWindow';
    case FilterId.disputeStatus:
      return 'statuses';
  }
}
